import React, { useState } from "react";
import axiosClient from "../../api/axiosClient";

function AddDepartment({ tenants, locations, selectedTenant, existing, onClose }) {
  const [form, setForm] = useState({
    tenant_id: existing?.tenant_id || selectedTenant || "",
    location_id: existing?.location_id || "",
    name: existing?.name || "",
    code: existing?.code || "",
    description: existing?.description || "",
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (existing) {
        await axiosClient.put(`/tenant/api/departments/${existing.id}`, form);
        alert("Department updated successfully");
      } else {
        await axiosClient.post(`/tenant/api/departments/create`, form);
        alert("Department created successfully");
      }
      onClose();
    } catch (err) {
      console.error("Error saving department:", err);
      alert("Failed to save department");
    }
  };

  return (
    <div
      className="modal show d-block"
      style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
    >
      <div className="modal-dialog modal-lg">
        <div className="modal-content">
          <div className="modal-header bg-primary text-white">
            <h5 className="modal-title">
              {existing ? "Edit Department" : "Add Department"}
            </h5>
            <button type="button" className="btn-close" onClick={onClose}></button>
          </div>
          <form onSubmit={handleSubmit}>
            <div className="modal-body">
              <div className="mb-3">
                <label className="form-label">Tenant</label>
                <select
                  className="form-select"
                  value={form.tenant_id}
                  onChange={(e) => setForm({ ...form, tenant_id: e.target.value })}
                  required
                >
                  <option value="">Select Tenant</option>
                  {tenants.map((t) => (
                    <option key={t.id} value={t.id}>
                      {t.name}
                    </option>
                  ))}
                </select>
              </div>

              <div className="mb-3">
                <label className="form-label">Location (Optional)</label>
                <select
                  className="form-select"
                  value={form.location_id}
                  onChange={(e) => setForm({ ...form, location_id: e.target.value })}
                >
                  <option value="">All Locations</option>
                  {locations.map((loc) => (
                    <option key={loc.id} value={loc.id}>
                      {loc.name}
                    </option>
                  ))}
                </select>
              </div>

              <div className="mb-3">
                <label className="form-label">Department Name</label>
                <input
                  type="text"
                  className="form-control"
                  value={form.name}
                  onChange={(e) => setForm({ ...form, name: e.target.value })}
                  required
                />
              </div>

              <div className="mb-3">
                <label className="form-label">Code</label>
                <input
                  type="text"
                  className="form-control"
                  value={form.code}
                  onChange={(e) => setForm({ ...form, code: e.target.value })}
                  required
                />
              </div>

              <div className="mb-3">
                <label className="form-label">Description</label>
                <textarea
                  className="form-control"
                  value={form.description}
                  onChange={(e) =>
                    setForm({ ...form, description: e.target.value })
                  }
                  rows="3"
                />
              </div>
            </div>

            <div className="modal-footer">
              <button type="submit" className="btn btn-success">
                💾 Save
              </button>
              <button
                type="button"
                className="btn btn-secondary"
                onClick={onClose}
              >
                ✖ Cancel
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default AddDepartment;
